import TypeFilters from './TypeFiltersContainer';
export default TypeFilters;



// WEBPACK FOOTER //
// ./src/components/TypeFilters/index.js